// extracted by mini-css-extract-plugin
export default {"root":"HorizontalLabelGroup_root__jTLe8","header":"HorizontalLabelGroup_header__Mdebt"};